const {gearByCatCollection} = require('./../../../gearList')
const {CAT_ARMOR} = require('./../../../gearCategoryList')

module.exports = gearByCatCollection[CAT_ARMOR].map(
  gearId => ({
    id: `smoldering_${gearId}`,
    gearId,
  })
)
